import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DataGrid } from "@mui/x-data-grid";
import { debounce } from "@mui/material";
import { Link } from "react-router-dom";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Close from "../../assets/images/close-icon.png";
import Typography from "@mui/material/Typography";
import "../../components/common/css/datatable.scss";
import Box from "@mui/material/Box";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader/Loader";
import { useForm } from "react-hook-form";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Select from "react-select";
import PageShell from "../../components/layout/PageShell";
import PageHead from "../../components/layout/PageHead";

const ManageDesignationReport = () => {
  const [corpCountry, setCorpCountry] = useState([]);
  const [countryId, setCountryId] = useState();
  let token = localStorage.getItem("accessToken");
  const [designations, setDesignations] = useState([]);
  const [DesignationID, setDesignationID] = useState();
  const [getDesignation, setDesignaton] = useState();
  const dispatch = useDispatch();
  const [id, setID] = useState();
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const requestColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div className="editButton">
              <EditOutlinedIcon />
            </div>
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "userId", headerName: "ID", width: 100 },

    {
      field: "firstname",
      headerName: "Username",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const userFullName =
          // params?.firstname + " " + params?.lastname;
          params?.row?.firstname.charAt(0).toUpperCase() +
          params?.row?.firstname.slice(1) +
          " " +
          params?.row?.lastname.charAt(0).toUpperCase() +
          params?.row?.lastname.slice(1);
        return (
          <>
            <div className="rowitem">{userFullName}</div>
          </>
        );
      },
    },
    {
      field: "country_name",
      headerName: "Country",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "designation",
      headerName: "Designation",
      flex: 1,
      minWidth: 250,
    },
    {
      field: "createdAt",
      headerName: "Joined At",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.createdAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
    {
      field: "updatedAt",
      headerName: "Last Updated",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const d = new Date(params?.row?.updatedAt);
        return (
          <>
            <div className="rowitem">{d.toDateString()}</div>
          </>
        );
      },
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/designation-report/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
          </div>
        );
      },
    },
  ];

  const handleQuery = useCallback(
    debounce((e) => {
      setQuery(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  useEffect(() => {
    getAllDesignations();
  }, [pageState.page, pageState.pageSize]);

  useEffect(() => {
    const getCountry = async () => {
      await axios
        .get(process.env.REACT_APP_API + "get-country")
        .then((res) => setCorpCountry(res.data.data))
        .catch((err) => console.log(err));
    };
    getCountry();
  }, []);

  const handleChangeManager = (e) => {
    setDesignationID(e.target.value);
    setDesignaton(e);
    fetchUserByCountryDesignation(e.target.value);
  };

  const handleCorpCountry = (e) => {
    const getCounryId = e.target.value;
    setCountryId(getCounryId);
    // getState(getCounryId);
  };

  const getAllDesignations = () => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-designation",
      headers: {
        "x-access-token": token,
      },
      data: {
        limit: 500,
        page: 1,
      },
    };

    axios(config)
      .then(function (response) {
        const data = response.data.data.rows;
        const options = data.map((d) => ({
          value: d.id,
          label: d?.designation,
        }));

        setDesignations(options);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const fetchUserByCountryDesignation = (DesignationID) => {
    let token = localStorage.getItem("accessToken");
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "userDetailsByCountryandDesignation",
      headers: {
        "x-access-token": token,
      },
      data: {
        country_id: countryId,
        // designation: DesignationID,
        level: DesignationID,
        page: pageState.page,
        limit: pageState.pageSize,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        // setReportUrl(response.data.data);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  return (
    <PageShell><PageHead title="Designation report" /><div className="list">
      <div className="listContainer">

        <div className="datatable">
          <Loader isLoading={loading} />

          <div className="datatableTitle manageUser-top">
            <h5 className="h5Title" style={{ textAlign: "center" }}>
              Manage Designations Report
            </h5>
          </div>
          <div className="desgniation-reportTop">
            <div className="dFlex custInput-div">
              <label className="cust-label">Country</label>
              <select
                className="txtInput"
                name="corporationCountry"
                onChange={(e) => handleCorpCountry(e)}
                value={countryId}
              >
                <option value="" disabled selected>
                  Select Country
                </option>
                {corpCountry?.map((getCon, index) => (
                  <option key={index} value={getCon?.id}>
                    {getCon?.country_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="dFlex custInput-div">
              <label className="cust-label">Designation</label>

              {/* <Select
                options={designations}
                onChange={handleChangeManager}
                value={getDesignation}
              /> */}

              <select
                className="txtInput"
                name="level_name"
                {...register("level_name", {
                  required: "This field is required",
                })}
                onChange={handleChangeManager}
              >
                <option value="" disabled selected hidden>
                  Select Level
                </option>
                <option value="1">Executives</option>
                <option value="2">VPs</option>
                <option value="3">Regional Manager</option>
                <option value="4">Consultant</option>
                  <option value="5">Referral</option>
              </select>
            </div>
          </div>
          <DataGrid
            className="datagrid"
            autoHeight
            rows={pageState.data}
            rowCount={pageState.total}
            rowsPerPageOptions={[10, 30, 50, 70, 100]}
            pagination
            page={pageState.page - 1}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage + 1 }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
            columns={userColumns.concat(actionColumn)}
          />
        </div>
      </div>
    </div></PageShell>
  );
};
export default ManageDesignationReport;
